import { app } from '../app.module'
app
  /**
   * @ngdoc SignupCtrl
   * @name SignupCtrl
   * @requires SignupService 新規登録機能用のサービス
   * @requires DialogService ダイアログ表示用のサービス
   * @description 新規登録のメインコントローラー
   */
  .controller(
    'SignupCtrl',
    function ($rootScope, $scope, $state, UserService, DialogService, RestangularService) {
      // 管理者じゃない場合、postページに移動
      if ($rootScope.isAdmin !== true) {
        $state.go('post')
      }

      // 編集状態にする
      $scope.isEdit = true

      // グループ一覧を取得
      UserService.Group.getGroupLists().then((groupLists) => {
        $scope.groups = groupLists
        $scope.groupId = null
      })

      /**
       * signup 新規登録処理
       */
      $scope.signup = function () {
        // 登録のエラー
        let errorTitle: string = null
        let errorMessage: string = null
        const endpoint = `/users/userByMail?email=${encodeURIComponent($scope.email)}`

        // メールの重複チェック
        RestangularService.request('GET', endpoint, null).then((result) => {
          // 既に登録済のメールアドレスではない場合、ユーザー追加を行う
          if (result[0].data.length === 0) {
            const addEndpoint = '/users/user'

            RestangularService.request('POST', addEndpoint, {
              username: $scope.username,
              email: $scope.email,
              password: $scope.password,
              company: $scope.company,
              telephone: $scope.telephone,
              groupId: $scope.groupId,
            })
              .then(() => {
                // 登録が成功した場合、ホームページにリダイレクト
                DialogService.showToast('ユーザーを追加しました。', 'success-toast')
                $state.reload()
              })
              .catch(() => {
                // 登録が失敗した場合、アラートを表示
                errorTitle = '登録が失敗しました。'
                errorMessage = 'アカウント登録に失敗しました。お手数ですが再度登録をお願いします。'
                DialogService.showError(errorTitle, errorMessage)
              })
          } else {
            // 既に登録済のメールアドレスの場合、アラートを表示
            errorMessage = '既に登録済のメールアドレスです。'
            DialogService.showError(errorTitle, errorMessage)
          }
        })
      }
    }
  )
